<template>
<div>
    <div class="logincent" v-show="!shows">
        <div class="conten" >
            <van-form  class="fromctent">
                <div class="phone ">
                    <select @click="selectHand">
                        <option :value ="this.address">{{this.address}}</option>
                    </select>
                    <van-field
                    v-model="mobile"
                    :placeholder="$t('sjhm')"
                    :border="true"
                    left-icon="friends"
                    clearable
                    size='large'
                    />
                </div>
                

                <van-field
                    style="height:46px"
                    left-icon="bag"
                    v-model="password"
                    center
                    clearable
                    :placeholder="$t('mm')"
                    >
                    <!-- <template #button>
                        <van-button size="small" @click="handldCode" class="codem" :disabled="disabled" color="#409EFF">{{Codename}}</van-button>
                    </template> -->
                </van-field>
				
				<div class="phone " style="margin-top: 10px;" @click="showPopup" v-show ="columns.length>1">
					<van-field label-width="0" readonly v-model="value"  :placeholder="$t('xzsq')" />
				</div>
				
                <div style="margin-top: 26px;">
                    <van-button  block color="#409EFF" class="loginbut" native-type="submit" @click="onSubmit">
                        <span style="font-size: 22px;">{{$t('login')}}</span>
                    </van-button
                >
                </div>
				
            </van-form>
            <div class="logintop">
                <div @click="goregin" >{{$t('zc')}}</div>
                <div @click="Retrievepas" >{{$t('zhmm')}}</div>
                
            </div>
            <!-- 社区弹窗 -->
			<van-popup v-model="showPicker" position="bottom" :style="{ height: '40%' }" >
				<van-picker
					:confirm-button-text="$t('qd')" :cancel-button-text="$t('qx')"
					ref="pickers"
					v-model="agent_id"
					show-toolbar
					value-key="name"
					:columns="columns"
					@cancel="showPicker = false"
					@confirm="onConfirm"
				/>
			</van-popup>
			
        </div>
    
    </div>
    <!-- <div v-show="shows" class="logincent">
        <div class="IDpasw">
            <van-form  class="fromctent">
                <van-field
                v-model="reg_id"
                :placeholder="$t('qsrID')"
                :border="true"
                left-icon="friends"
                clearable
                size='large'
                />

                <van-field
                v-model="password"
                :placeholder="$t('qsrmm')"
                :border="true"
                left-icon="bag"
                clearable
                size='large'
                type="password"
                />
                <div style="margin-top: 26px;">
                    <van-button  block color="#409EFF" class="loginbut" native-type="submit" @click="onSubmitID">
                        <span style="font-size: 22px;">{{$t('login')}}</span>
                    </van-button
                >
                </div>
            </van-form>
            <div class="logintop">
                <div @click="handswitch" >{{$t('ysjhmdl')}}</div>
                <div @click="Retrievepas" >{{$t('zhmm')}}</div>
            </div>
            
        </div>
    </div> -->
</div>
  
</template>

<script>
import { Toast } from 'vant';
export default {
    data(){
        return{
            address:localStorage.getItem('address')?localStorage.getItem('address'):'+86',
            mobile:'',
            verify_code:'',
            Codename:this.$t('fsyzm'),
            disabled:false,
            shows:false,
            // ID密码
            reg_id:'',
            password:'',
			showPicker:false,
			columns: [],
			value:'',
			agent_id:''
        }
    },
    mounted(){
        // let type =  navigator.systemLanguage || navigator.language;
        // if(type.indexOf("zh")!=0){
        //     this.shows = true
        // }
        
    },  
    methods:{
        selectHand(){
            this.$router.push({path:'/indexbar'})
            
        },
        // 验证码
        handldCode(){


            if(!this.mobile){
                Toast.fail(this.$t('qsrsjhm'));
                return false
            }
            
            let mobiles =this.address+'-'+ this.mobile
            let data = {
                method:'co.sms.code.get',
                mobile:mobiles
            }
            console.log(data)

            this.$serve(data).then(res=>{
                if(res.data.code==0){
                    this.disabled = true
                    let second = 60
                    var clearTimeSet=setInterval( () =>{
                        this.Codename = second+this.$t('mhzxhq')
                        second=second-1
                    if(second==0){
                        clearInterval(clearTimeSet);
                        this.disabled = false
                        this.Codename = this.$t('fsyzm')
                    }
                    }, 1000);
                    // this.verify_code = res.data.data.verify_code
                }else{
                    Toast.fail(this.$t('hqyzmsb'));
                }

            })
        },
        // 登录
        onSubmit(){
            console.log(`444`,this.address)
            let mobiles
            if(this.address=='+86'){
                 mobiles = this.mobile
            }else{
                 mobiles = this.address+'-'+ this.mobile
            }
			let params = {
				method:'co.wx.user.agent.list',
				mobile:mobiles,
				password:this.$md5(this.password),
			}
			this.$serve(params).then(res=>{
				console.log(res.data.data)
				if(res.data.code==0){
					this.columns=res.data.data
					if(this.columns.length == 1){
						this.login(res.data.data[0])
					}
				}else{
					Toast.fail(this.$t('zhhyzmcw'));
				}
			})
        },
        // 切换ID和密码登录
        handswitch(){
            let type =  navigator.systemLanguage || navigator.language;
            if(type == 'zh'){
                this.shows = !this.shows
            }else{
                this.shows = true
            }
            
        },

        goregin(){
            this.$router.push({ path: '/register' })
        },
        Retrievepas(){
            this.$router.push({ path: '/retpassword' })
        },
        // ================ID和密码登录========================

        onSubmitID(){
            let data = {
                method:'co.wx.id.login',
                reg_id:this.reg_id,
                password:this.$md5(this.password)
            }
            this.$serve(data).then(res=>{
                if(res.data.code==0){
                    let getTokendata = JSON.stringify(res.data.data)
                    localStorage.setItem('datauser',getTokendata)
                    this.$router.push({ path: '/' })
                }else{
                    Toast.fail(this.$t('zhhmmcw'));
                }
            })
        },
		// ===========================
		showPopup() {
			this.showPicker = true;
		},
		onConfirm(value) {
			this.login(value)
			// this.value = value.name;
			this.showPicker = false;
		},
		login(value){
            console.log(`444`,this.address)
			let mobiles
			if(this.address=='+86'){
			     mobiles = this.mobile
			}else{
			     mobiles = this.address+'-'+ this.mobile
			}
			let data = {
			    method:'co.wx.pwd.login',//'co.wx.login',
			    password:this.$md5(this.password),
			    mobile:mobiles,
			    agent_id:value.id,
			    platform:'pwa',
                person_type:value.person_type
			}
			this.$serve(data).then(res=>{
			    console.log(res)
			    if(res.data.code==0){
			       let getTokendata = JSON.stringify(res.data.data)
			       localStorage.setItem('datauser',getTokendata)
			        this.$router.push({ path: '/' })
			    }else{
			        Toast.fail(this.$t('zhhyzmcw'));
			    }
			})
		}
    }
}
</script>

<style scoped>
.logincent {
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.conten {
  width: 90%;
  /* height: 300px; */
  padding: 0 0 30px 0;
  margin-top: 47%;
  border-radius: 10px;
  box-shadow: #d5d5d5 0px 0px 10px;
}
.fromctent{
    width: 88%;
    margin: 0 auto;
    margin-top:53px;
}
.fromctent >>>.van-field__left-icon .van-icon-friends{
    font-size: 26px;
    margin-left: -5px;
    color: #CCCCCC;
}
.fromctent >>>.van-cell--large{
    border: 1px solid #DBDBDB;
    border-radius: 3px;
    padding: 10px;
    margin-bottom: 10px;
}
.fromctent >>>.van-cell--center{
    border: 1px solid #DBDBDB;
    border-radius: 5px;
    padding: 6px;
}
.fromctent >>>.van-field__left-icon .van-icon-bag{
    font-size: 28px;
    /* margin-left: 2px; */
    color: #CCCCCC;
}
.codem{
    border-radius:4px ;
}
.loginbut{
    border-radius:5px ;
}
/* ID密码登录 */

.IDpasw{
    width: 90%;
    height: 300px;
    margin-top: 47%;
    border-radius: 10px;
    box-shadow: #d5d5d5 0px 0px 10px;
}
.logintop{
    padding: 0 20px;
    margin-top:30px;color:#409EFF;
    display: flex;
    justify-content: space-between;
}
.phone{
    display: flex;
    height: 46px;
    border: 1px solid #DBDBDB;
    margin-bottom: 10px;
    border-radius: 5px;
    padding:0px 2px;
}
.phone select{
    height: 42px;
    border: none;
    line-height: 35px;
    padding:2px;
    border-right: 1px solid #DBDBDB;
    background-color: #fff;
    color: #323233;
}
.fromctent .phone >>> .van-cell--large{
    border: none;
    border-radius: 0px;
}   
</style>